import { getDepartmentIdByName } from "../components/Clientes/getDepartamentos"


export const getStates = async() =>{
    //https://www.datos.gov.co/resource/xdk5-pm3f.json?$select=departamento&$group=departamento&$order=departamento
   return await fetch(`https://api-colombia.com/api/v1/Department`,{
    method:"GET",
    headers:{
        'Content-Type': 'application/json'
    }
   })
}

export const getCities = async(departamento) =>{
    const depId=getDepartmentIdByName(departamento)
    return await fetch(`https://api-colombia.com/api/v1/Department/${depId}/cities
`,{
        method:"GET",
        headers:{
            'Content-Type': 'application/json'
        }
       })
}


